import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteAlertUrl } from "../../config";
import { Status } from "../../common/constants";
import { RootState } from "../../store";
import api from "../../api";
import { IInitialSliceState } from "../../common/types/commonTypes";

const initialState: IInitialSliceState = {
    status: null,
    error: null,
    msg: null
};

interface IDeleteAlertResponse {
    message: string
}

interface IDeleteAlertModalPayload {
    alertId: string;
    jobId: string;
}

export const deleteAlertModal = createAsyncThunk("deleteAlert", async (deleteAlertModalPayload: IDeleteAlertModalPayload, { rejectWithValue }) => {
    const { alertId, jobId } = deleteAlertModalPayload;
    try {
        const response = await api.delete<IDeleteAlertResponse>(deleteAlertUrl + `?alertId=${alertId}`);
        const deleteAlertResponse: IDeleteAlertResponse = response.data;
        return deleteAlertResponse;
    } catch (error) {
        throw rejectWithValue(error);
    }
}
);

const deleteAlertModalSlice = createSlice({
    name: "deleteAlert",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(deleteAlertModal.pending, (state) => {
                state.status = Status.PENDING;
                state.msg = null;
            })
            .addCase(deleteAlertModal.fulfilled, (state, action) => {
                state.msg = action.payload.message;
                state.status = Status.SUCCESS;
            })
            .addCase(deleteAlertModal.rejected, (state, action) => {
                const errorPayload = action.payload as { response?: { data?: { error?: { message?: string }, message?: string } } };
                state.msg = errorPayload.response?.data?.error?.message || errorPayload.response?.data?.message || 'Unknown error occurred';
                state.status = Status.FAILED;
            });
    },
});

export const selector = (state: RootState) => state.deleteAlertApi;

export const reducer = deleteAlertModalSlice.reducer;
